'use client'
import clsx from 'clsx'
import classes from './productlistheader.module.css'
import { Heading } from '@/components/Heading'
import { Tab, Tabs } from '@/components/Tabs'
import { useTranslation } from 'react-i18next'
import { useUser } from '@/eshop/hooks/useUser'
import { useMemo } from 'react'
import { useRouter } from 'next/navigation'

export default function ProductListHeader() {
    const { t } = useTranslation()
    const user = useUser()
    const { push } = useRouter()

    const tabs: Tab[] = useMemo(
        () =>
            [
                {
                    content: null,
                    key: 'list',
                    label: t('eshop.productlist.header.products'),
                },
                user && !user.isAnonymous
                    ? {
                          content: null,
                          key: 'orders',
                          label: t('eshop.productlist.header.orders'),
                      }
                    : undefined,
            ].filter((x) => !!x) as Tab[],
        [t, user]
    )

    return (
        <>
            <div className={classes.eshoplistwrapper}>
                <Tabs
                    tabs={tabs}
                    onTabChange={(key) => {
                        const url =
                            key === 'orders' ? '/eshop/user/orders' : '/eshop'
                        push(url)
                    }}
                    align="left"
                    hideBorder
                />
            </div>

            <div
                className={clsx(
                    classes.eshoplistheader,
                    'flex items-center pl-4 lg:pl-40 border-b border-gray-light2'
                )}
            >
                <Heading
                    tag="h1"
                    text={t('eshop.title')}
                    className="text-2xl sm:text-3xl lg:text-4xl"
                />
            </div>
        </>
    )
}
